import { useQuery } from '@tanstack/react-query';
import { membersApi, MemberListParams } from '../api/members';
import { MemberListItemDto } from '../types';

export function useMemberList(params?: MemberListParams) {
  return useQuery<MemberListItemDto[], Error>({
    queryKey: ['members', params],
    queryFn: () => membersApi.list(params),
  });
}
